import { Asset } from '@api/api';
import { useAssetsPrices } from '@queries/useAssetsPrices';
import { useMemo } from 'react';

export const useAssets = (assets: Asset[]) => {
  const { data: assetsPrices } = useAssetsPrices(
    assets?.map((asset) => asset.ticker),
    Boolean(assets?.length),
  );

  const coinPrices = useMemo(() => {
    if (!assets?.length) return [];

    return assets?.map((asset) => {
      const coinPrice = assetsPrices?.find(
        ({ ticker }) => asset.ticker.toLowerCase() === ticker.toLowerCase(),
      );

      return {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: asset.image?.hash,
        coingeckoImage: asset.coingeckoImage,
        value: coinPrice?.priceUsd,
        perc: coinPrice?.priceChange24Hours,
        text: asset.ticker,
      };
    });
  }, [assets, assetsPrices]);

  return coinPrices;
};
